import { Suspense } from "react";
import { AuthLink, AuthLinkParams } from "./AuthLink";

export function SignupLink({ children, className, onClick }: AuthLinkParams) {
  return (
    <Suspense>
      <AuthLink className={className} mode={"signup"} onClick={onClick}>
        {children}
      </AuthLink>
    </Suspense>
  );
}
